var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-container", { attrs: { fluid: "" } }, [
    _c(
      "div",
      { staticClass: "text-left" },
      [
        _c(
          "h4",
          {
            staticClass: "pa-0 header-font primary--text mb-2",
            staticStyle: { "font-size": "22px" },
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "playerRecruitment.radarDescription.basicStatistics.title"
                )
              )
            ),
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.playerSeasonBasicStats, function (playerSeason) {
          return _c("div", [
            _c("div", {
              staticClass: "pb-2 body-1 primary--text",
              domProps: { innerHTML: _vm._s(playerSeason.text) },
            }),
          ])
        }),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "pa-0 header-font primary--text mt-5",
            staticStyle: { "font-size": "22px" },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("playerRecruitment.radarDescription.description"))
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "pt-2 body-1 primary--text",
          domProps: { innerHTML: _vm._s(_vm.descriptionText) },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }